var _style, _path, _circle, _path2, _path3, _circle2, _line, _line2, _path4, _circle3, _path5, _path6, _circle4, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;stroke:url(#SVGID_2_);stroke-width:15;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:#FFFFFF;stroke:url(#SVGID_5_);stroke-width:15;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:url(#SVGID_6_);stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;stroke:url(#SVGID_7_);stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:#FFFFFF;stroke:url(#SVGID_9_);stroke-width:15;stroke-miterlimit:10;}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:#FFFFFF;stroke:url(#SVGID_12_);stroke-width:15;stroke-miterlimit:10;}\n\t.st12{fill:url(#SVGID_13_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3274,
    y1: 417.7517,
    x2: 189.2301,
    y2: 417.7517,
    gradientTransform: "matrix(1 0 0 -1 0 512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.3,35.2v-28c0-4.1,3.3-7.4,7.4-7.4h28c4.1,0,7.4,3.3,7.4,7.4s-3.3,7.4-7.4,7.4H15.1v20.7 c0,4.1-3.3,7.4-7.4,7.4S0.3,39.3,0.3,35.2z M181.9-0.2h-28c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h20.7v20.7 c0,4.1,3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4v-28C189.2,3.1,185.9-0.2,181.9-0.2z M35.7,173.9H15.1v-20.7c0-4.1-3.3-7.4-7.4-7.4 s-7.4,3.3-7.4,7.4v28c0,4.1,3.3,7.4,7.4,7.4h28c4.1,0,7.4-3.3,7.4-7.4C43.1,177.2,39.8,173.9,35.7,173.9z M181.9,145.9 c-4.1,0-7.4,3.3-7.4,7.4v20.7h-20.7c-4.1,0-7.4,3.3-7.4,7.4c0,4.1,3.3,7.4,7.4,7.4h28c4.1,0,7.4-3.3,7.4-7.4v-28 C189.2,149.2,185.9,145.9,181.9,145.9z M88.3,36.1v44.3c0,4.1-3.3,7.4-7.4,7.4H36.7c-4.1,0-7.4-3.3-7.4-7.4V36.1 c0-4.1,3.3-7.4,7.4-7.4h44.3C85,28.8,88.3,32.1,88.3,36.1z M73.6,43.5H44V73h29.5V43.5z M156.6,87.8h-44.3c-4.1,0-7.4-3.3-7.4-7.4 V36.1c0-4.1,3.3-7.4,7.4-7.4h44.3c4.1,0,7.4,3.3,7.4,7.4v44.3C164,84.5,160.7,87.8,156.6,87.8z M149.2,43.5h-29.5V73h29.5V43.5z  M88.3,111.8V156c0,4.1-3.3,7.4-7.4,7.4H36.7c-4.1,0-7.4-3.3-7.4-7.4v-44.3c0-4.1,3.3-7.4,7.4-7.4h44.3 C85,104.4,88.3,107.7,88.3,111.8z M73.6,119.2H44v29.5h29.5V119.2z M147.1,153.9h-25.3c-4.1,0-7.4-3.3-7.4-7.4v-25.3 c0-4.1,3.3-7.4,7.4-7.4h25.3c4.1,0,7.4,3.3,7.4,7.4v25.3C154.5,150.6,151.2,153.9,147.1,153.9z M139.7,128.7h-10.5v10.5h10.5 V128.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.0996,
    y1: 159.7858,
    x2: 224.3883,
    y2: 159.7858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 171.7,
    cy: 159.8,
    r: 45.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.2251,
    y1: 158.3472,
    x2: 196.3995,
    y2: 158.3472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.4,146.2c1.6,2,1.3,4.9-0.7,6.5c0,0,0,0,0,0l-23.1,18.5c-1.8,1.5-4.5,1.3-6.1-0.3L151.6,157 c-1.8-1.8-1.8-4.7,0-6.5c1.8-1.8,4.7-1.8,6.5,0l10.9,10.9l19.9-15.9C190.9,143.9,193.8,144.2,195.4,146.2 C195.4,146.2,195.4,146.2,195.4,146.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.9709,
    y1: 417.7517,
    x2: 475.8736,
    y2: 417.7517,
    gradientTransform: "matrix(1 0 0 -1 0 512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287,35.2v-28c0-4.1,3.3-7.4,7.4-7.4h28c4.1,0,7.4,3.3,7.4,7.4s-3.3,7.4-7.4,7.4h-20.7v20.7 c0,4.1-3.3,7.4-7.4,7.4S287,39.3,287,35.2z M468.5-0.2h-28c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h20.7v20.7 c0,4.1,3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4v-28C475.9,3.1,472.6-0.2,468.5-0.2z M322.4,173.9h-20.7v-20.7 c0-4.1-3.3-7.4-7.4-7.4s-7.4,3.3-7.4,7.4v28c0,4.1,3.3,7.4,7.4,7.4h28c4.1,0,7.4-3.3,7.4-7.4C329.8,177.2,326.5,173.9,322.4,173.9 z M468.5,145.9c-4.1,0-7.4,3.3-7.4,7.4v20.7h-20.7c-4.1,0-7.4,3.3-7.4,7.4c0,4.1,3.3,7.4,7.4,7.4h28c4.1,0,7.4-3.3,7.4-7.4v-28 C475.9,149.2,472.6,145.9,468.5,145.9z M375,36.1v44.3c0,4.1-3.3,7.4-7.4,7.4h-44.3c-4.1,0-7.4-3.3-7.4-7.4V36.1 c0-4.1,3.3-7.4,7.4-7.4h44.3C371.7,28.8,375,32.1,375,36.1z M360.2,43.5h-29.5V73h29.5V43.5z M443.2,87.8h-44.3 c-4.1,0-7.4-3.3-7.4-7.4V36.1c0-4.1,3.3-7.4,7.4-7.4h44.3c4.1,0,7.4,3.3,7.4,7.4v44.3C450.6,84.5,447.3,87.8,443.2,87.8z  M435.8,43.5h-29.5V73h29.5V43.5z M375,111.8V156c0,4.1-3.3,7.4-7.4,7.4h-44.3c-4.1,0-7.4-3.3-7.4-7.4v-44.3 c0-4.1,3.3-7.4,7.4-7.4h44.3C371.7,104.4,375,107.7,375,111.8z M360.2,119.2h-29.5v29.5h29.5V119.2z M433.7,153.9h-25.3 c-4.1,0-7.4-3.3-7.4-7.4v-25.3c0-4.1,3.3-7.4,7.4-7.4h25.3c4.1,0,7.4,3.3,7.4,7.4v25.3C441.1,150.6,437.8,153.9,433.7,153.9z  M426.3,128.7h-10.5v10.5h10.5V128.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.743,
    y1: 159.7858,
    x2: 511.0317,
    y2: 159.7858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 458.4,
    cy: 159.8,
    r: 45.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.2197,
    y1: 159.9903,
    x2: 478.7747,
    y2: 159.9903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 473.8,
    y1: 147.5,
    x2: 444.2,
    y2: 172.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.2197,
    y1: 159.9903,
    x2: 478.7747,
    y2: 159.9903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 444.2,
    y1: 147.5,
    x2: 473.8,
    y2: 172.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3274,
    y1: 119.7721,
    x2: 189.2301,
    y2: 119.7721,
    gradientTransform: "matrix(1 0 0 -1 0 512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M0.3,333.2v-28c0-4.1,3.3-7.4,7.4-7.4h28c4.1,0,7.4,3.3,7.4,7.4s-3.3,7.4-7.4,7.4H15.1v20.7 c0,4.1-3.3,7.4-7.4,7.4S0.3,337.3,0.3,333.2z M181.9,297.8h-28c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h20.7v20.7 c0,4.1,3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4v-28C189.2,301.1,185.9,297.8,181.9,297.8z M35.7,471.9H15.1v-20.7 c0-4.1-3.3-7.4-7.4-7.4s-7.4,3.3-7.4,7.4v28c0,4.1,3.3,7.4,7.4,7.4h28c4.1,0,7.4-3.3,7.4-7.4S39.8,471.9,35.7,471.9z M181.9,443.9 c-4.1,0-7.4,3.3-7.4,7.4v20.7h-20.7c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h28c4.1,0,7.4-3.3,7.4-7.4v-28 C189.2,447.2,185.9,443.9,181.9,443.9z M88.3,334.1v44.3c0,4.1-3.3,7.4-7.4,7.4H36.7c-4.1,0-7.4-3.3-7.4-7.4v-44.3 c0-4.1,3.3-7.4,7.4-7.4h44.3C85,326.7,88.3,330,88.3,334.1z M73.6,341.5H44V371h29.5V341.5z M156.6,385.8h-44.3 c-4.1,0-7.4-3.3-7.4-7.4v-44.3c0-4.1,3.3-7.4,7.4-7.4h44.3c4.1,0,7.4,3.3,7.4,7.4v44.3C164,382.5,160.7,385.8,156.6,385.8z  M149.2,341.5h-29.5V371h29.5V341.5z M88.3,409.8V454c0,4.1-3.3,7.4-7.4,7.4H36.7c-4.1,0-7.4-3.3-7.4-7.4v-44.3 c0-4.1,3.3-7.4,7.4-7.4h44.3C85,402.4,88.3,405.7,88.3,409.8z M73.6,417.1H44v29.5h29.5V417.1z M147.1,451.9h-25.3 c-4.1,0-7.4-3.3-7.4-7.4v-25.3c0-4.1,3.3-7.4,7.4-7.4h25.3c4.1,0,7.4,3.3,7.4,7.4v25.3C154.5,448.6,151.2,451.9,147.1,451.9z  M139.7,426.6h-10.5v10.5h10.5V426.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.0996,
    y1: 457.7654,
    x2: 224.3883,
    y2: 457.7654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 171.7,
    cy: 457.8,
    r: 45.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.2251,
    y1: 456.3268,
    x2: 196.3995,
    y2: 456.3268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M195.4,444.2c1.6,2,1.3,4.9-0.7,6.5c0,0,0,0,0,0l-23.1,18.5c-1.8,1.5-4.5,1.3-6.1-0.3L151.6,455 c-1.8-1.8-1.8-4.7,0-6.5c1.8-1.8,4.7-1.8,6.5,0l10.9,10.9l19.9-15.9C190.9,441.9,193.8,442.2,195.4,444.2 C195.4,444.2,195.4,444.2,195.4,444.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.9709,
    y1: 119.7721,
    x2: 475.8736,
    y2: 119.7721,
    gradientTransform: "matrix(1 0 0 -1 0 512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M287,333.2v-28c0-4.1,3.3-7.4,7.4-7.4h28c4.1,0,7.4,3.3,7.4,7.4s-3.3,7.4-7.4,7.4h-20.7v20.7 c0,4.1-3.3,7.4-7.4,7.4S287,337.3,287,333.2z M468.5,297.8h-28c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h20.7v20.7 c0,4.1,3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4v-28C475.9,301.1,472.6,297.8,468.5,297.8z M322.4,471.9h-20.7v-20.7 c0-4.1-3.3-7.4-7.4-7.4s-7.4,3.3-7.4,7.4v28c0,4.1,3.3,7.4,7.4,7.4h28c4.1,0,7.4-3.3,7.4-7.4S326.5,471.9,322.4,471.9z  M468.5,443.9c-4.1,0-7.4,3.3-7.4,7.4v20.7h-20.7c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h28c4.1,0,7.4-3.3,7.4-7.4v-28 C475.9,447.2,472.6,443.9,468.5,443.9z M375,334.1v44.3c0,4.1-3.3,7.4-7.4,7.4h-44.3c-4.1,0-7.4-3.3-7.4-7.4v-44.3 c0-4.1,3.3-7.4,7.4-7.4h44.3C371.7,326.7,375,330,375,334.1z M360.2,341.5h-29.5V371h29.5V341.5z M443.2,385.8h-44.3 c-4.1,0-7.4-3.3-7.4-7.4v-44.3c0-4.1,3.3-7.4,7.4-7.4h44.3c4.1,0,7.4,3.3,7.4,7.4v44.3C450.6,382.5,447.3,385.8,443.2,385.8z  M435.8,341.5h-29.5V371h29.5V341.5z M375,409.8V454c0,4.1-3.3,7.4-7.4,7.4h-44.3c-4.1,0-7.4-3.3-7.4-7.4v-44.3 c0-4.1,3.3-7.4,7.4-7.4h44.3C371.7,402.4,375,405.7,375,409.8z M360.2,417.1h-29.5v29.5h29.5V417.1z M433.7,451.9h-25.3 c-4.1,0-7.4-3.3-7.4-7.4v-25.3c0-4.1,3.3-7.4,7.4-7.4h25.3c4.1,0,7.4,3.3,7.4,7.4v25.3C441.1,448.6,437.8,451.9,433.7,451.9z  M426.3,426.6h-10.5v10.5h10.5V426.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.743,
    y1: 457.7654,
    x2: 511.0317,
    y2: 457.7654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 458.4,
    cy: 457.8,
    r: 45.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.8685,
    y1: 456.3268,
    x2: 483.0429,
    y2: 456.3268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA80FC"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M482,444.2c1.6,2,1.3,4.9-0.7,6.5c0,0,0,0,0,0l-23.1,18.5c-1.8,1.5-4.5,1.3-6.1-0.3L438.2,455 c-1.8-1.8-1.8-4.7,0-6.5c1.8-1.8,4.7-1.8,6.5,0l10.9,10.9l19.9-15.9C477.5,441.9,480.4,442.2,482,444.2 C482,444.2,482,444.2,482,444.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.19d0d3de3edf73452933280e0250bd49.svg";
export { ForwardRef as ReactComponent };